var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailTemplateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0475 16.5312H3.50586C2.64128 16.5312 1.94336 15.8333 1.94336 14.9688V5.59375C1.94336 4.72917 2.64128 4.03125 3.50586 4.03125H17.0475C17.9121 4.03125 18.61 4.72917 18.61 5.59375V14.9688C18.61 15.8333 17.9121 16.5312 17.0475 16.5312ZM3.50586 5.07292C3.21419 5.07292 2.98503 5.30208 2.98503 5.59375V14.9688C2.98503 15.2604 3.21419 15.4896 3.50586 15.4896H17.0475C17.3392 15.4896 17.5684 15.2604 17.5684 14.9688V5.59375C17.5684 5.30208 17.3392 5.07292 17.0475 5.07292H3.50586Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2761 12.3218C9.54692 12.3218 8.88025 12.0302 8.38025 11.4989L2.9115 5.68642C2.71358 5.47809 2.724 5.14476 2.93233 4.94684C3.14067 4.74892 3.474 4.75934 3.67192 4.96767L9.14067 10.7802C9.73442 11.4156 10.8178 11.4156 11.4115 10.7802L16.8803 4.97809C17.0782 4.76976 17.4115 4.75934 17.6198 4.95726C17.8282 5.15517 17.8386 5.48851 17.6407 5.69684L12.1719 11.5093C11.6719 12.0406 11.0052 12.3323 10.2761 12.3323V12.3218Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailTemplateIcon);
export default __webpack_public_path__ + "static/media/email-template-icon.da4d2a78372321421969cec52e3ef979.svg";
export { ForwardRef as ReactComponent };